import { Injectable } from '@angular/core';
import { SelectedProduct, CheckoutState } from '../checkout/checkout.reducer';
import { LocalStorageService } from './local-storage.service';

@Injectable()
export class CheckoutService {
  private product: SelectedProduct;
  private checkout: CheckoutState;

  constructor(private localStorageService: LocalStorageService) { }

  public setSelectedProduct(product: SelectedProduct) {
    this.product = product;
    this.localStorageService.set('selected-product', product);
  }

  public getSelectedProduct(): SelectedProduct {
    return this.product || this.localStorageService.get('selected-product') as SelectedProduct;
  }

  public setCheckout(checkout: CheckoutState) {
    this.checkout = checkout;
    this.localStorageService.set('checkout', checkout);
  }

  public getCheckout(): CheckoutState {
    return this.checkout || this.localStorageService.get('checkout') as CheckoutState;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/checkout.service.ts